/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Catalog Api
 * REST api
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiWizardResultItemsGetCollection200,
  ApiWizardResultItemsGetCollectionParams,
  WizardResultItem,
  WizardResultItemJsonld
} from './schemas';

import { apiCatalog } from '../../apiCatalog';



// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type api_wizard_result_items_get_collectionResponse200 = {
  data: ApiWizardResultItemsGetCollection200
  status: 200
}

export type api_wizard_result_items_get_collectionResponseSuccess = (api_wizard_result_items_get_collectionResponse200) & {
  headers: Headers;
};
;

export type api_wizard_result_items_get_collectionResponse = (api_wizard_result_items_get_collectionResponseSuccess)

export const getApiWizardResultItemsGetCollectionUrl = (params?: ApiWizardResultItemsGetCollectionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/wizard_result_items?${stringifiedParams}` : `/api/wizard_result_items`
}

/**
 * Retrieves the collection of WizardResultItem resources.
 * @summary Retrieves the collection of WizardResultItem resources.
 */
export const api_wizard_result_items_get_collection = async (params?: ApiWizardResultItemsGetCollectionParams, options?: RequestInit): Promise<api_wizard_result_items_get_collectionResponse> => {

  return apiCatalog<api_wizard_result_items_get_collectionResponse>(getApiWizardResultItemsGetCollectionUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getApiWizardResultItemsGetCollectionQueryKey = (params?: ApiWizardResultItemsGetCollectionParams,) => {
    return [
    `/api/wizard_result_items`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiWizardResultItemsGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof api_wizard_result_items_get_collection>>, TError = unknown>(params?: ApiWizardResultItemsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_wizard_result_items_get_collection>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiWizardResultItemsGetCollectionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof api_wizard_result_items_get_collection>>> = ({ signal }) => api_wizard_result_items_get_collection(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof api_wizard_result_items_get_collection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiWizardResultItemsGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof api_wizard_result_items_get_collection>>>
export type ApiWizardResultItemsGetCollectionQueryError = unknown


export function useApiWizardResultItemsGetCollection<TData = Awaited<ReturnType<typeof api_wizard_result_items_get_collection>>, TError = unknown>(
 params: undefined |  ApiWizardResultItemsGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_wizard_result_items_get_collection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof api_wizard_result_items_get_collection>>,
          TError,
          Awaited<ReturnType<typeof api_wizard_result_items_get_collection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiWizardResultItemsGetCollection<TData = Awaited<ReturnType<typeof api_wizard_result_items_get_collection>>, TError = unknown>(
 params?: ApiWizardResultItemsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_wizard_result_items_get_collection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof api_wizard_result_items_get_collection>>,
          TError,
          Awaited<ReturnType<typeof api_wizard_result_items_get_collection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiWizardResultItemsGetCollection<TData = Awaited<ReturnType<typeof api_wizard_result_items_get_collection>>, TError = unknown>(
 params?: ApiWizardResultItemsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_wizard_result_items_get_collection>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of WizardResultItem resources.
 */

export function useApiWizardResultItemsGetCollection<TData = Awaited<ReturnType<typeof api_wizard_result_items_get_collection>>, TError = unknown>(
 params?: ApiWizardResultItemsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_wizard_result_items_get_collection>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiWizardResultItemsGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type api_wizard_result_items_postResponse201 = {
  data: WizardResultItemJsonld
  status: 201
}

export type api_wizard_result_items_postResponse400 = {
  data: void
  status: 400
}

export type api_wizard_result_items_postResponse422 = {
  data: void
  status: 422
}

export type api_wizard_result_items_postResponseSuccess = (api_wizard_result_items_postResponse201) & {
  headers: Headers;
};
export type api_wizard_result_items_postResponseError = (api_wizard_result_items_postResponse400 | api_wizard_result_items_postResponse422) & {
  headers: Headers;
};

export type api_wizard_result_items_postResponse = (api_wizard_result_items_postResponseSuccess | api_wizard_result_items_postResponseError)

export const getApiWizardResultItemsPostUrl = () => {




  return `/api/wizard_result_items`
}

/**
 * Creates a WizardResultItem resource.
 * @summary Creates a WizardResultItem resource.
 */
export const api_wizard_result_items_post = async (apiWizardResultItemsPostBody: NonReadonly<WizardResultItemJsonld | WizardResultItem>, options?: RequestInit): Promise<api_wizard_result_items_postResponse> => {

  return apiCatalog<api_wizard_result_items_postResponse>(getApiWizardResultItemsPostUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: JSON.stringify(apiWizardResultItemsPostBody)
  }
);}





export const getApiWizardResultItemsPostMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof api_wizard_result_items_post>>, TError,{data: NonReadonly<WizardResultItemJsonld | WizardResultItem>}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof api_wizard_result_items_post>>, TError,{data: NonReadonly<WizardResultItemJsonld | WizardResultItem>}, TContext> => {

const mutationKey = ['apiWizardResultItemsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof api_wizard_result_items_post>>, {data: NonReadonly<WizardResultItemJsonld | WizardResultItem>}> = (props) => {
          const {data} = props ?? {};

          return  api_wizard_result_items_post(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiWizardResultItemsPostMutationResult = NonNullable<Awaited<ReturnType<typeof api_wizard_result_items_post>>>
    export type ApiWizardResultItemsPostMutationBody = NonReadonly<WizardResultItemJsonld | WizardResultItem>
    export type ApiWizardResultItemsPostMutationError = void

    /**
 * @summary Creates a WizardResultItem resource.
 */
export const useApiWizardResultItemsPost = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof api_wizard_result_items_post>>, TError,{data: NonReadonly<WizardResultItemJsonld | WizardResultItem>}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof api_wizard_result_items_post>>,
        TError,
        {data: NonReadonly<WizardResultItemJsonld | WizardResultItem>},
        TContext
      > => {
      return useMutation(getApiWizardResultItemsPostMutationOptions(options), queryClient);
    }
    export type api_wizard_result_items_id_getResponse200 = {
  data: WizardResultItemJsonld
  status: 200
}

export type api_wizard_result_items_id_getResponse404 = {
  data: void
  status: 404
}

export type api_wizard_result_items_id_getResponseSuccess = (api_wizard_result_items_id_getResponse200) & {
  headers: Headers;
};
export type api_wizard_result_items_id_getResponseError = (api_wizard_result_items_id_getResponse404) & {
  headers: Headers;
};

export type api_wizard_result_items_id_getResponse = (api_wizard_result_items_id_getResponseSuccess | api_wizard_result_items_id_getResponseError)

export const getApiWizardResultItemsIdGetUrl = (id: string,) => {




  return `/api/wizard_result_items/${id}`
}

/**
 * Retrieves a WizardResultItem resource.
 * @summary Retrieves a WizardResultItem resource.
 */
export const api_wizard_result_items_id_get = async (id: string, options?: RequestInit): Promise<api_wizard_result_items_id_getResponse> => {

  return apiCatalog<api_wizard_result_items_id_getResponse>(getApiWizardResultItemsIdGetUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getApiWizardResultItemsIdGetQueryKey = (id: string,) => {
    return [
    `/api/wizard_result_items/${id}`
    ] as const;
    }


export const getApiWizardResultItemsIdGetQueryOptions = <TData = Awaited<ReturnType<typeof api_wizard_result_items_id_get>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_wizard_result_items_id_get>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiWizardResultItemsIdGetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof api_wizard_result_items_id_get>>> = ({ signal }) => api_wizard_result_items_id_get(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof api_wizard_result_items_id_get>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiWizardResultItemsIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof api_wizard_result_items_id_get>>>
export type ApiWizardResultItemsIdGetQueryError = void


export function useApiWizardResultItemsIdGet<TData = Awaited<ReturnType<typeof api_wizard_result_items_id_get>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_wizard_result_items_id_get>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof api_wizard_result_items_id_get>>,
          TError,
          Awaited<ReturnType<typeof api_wizard_result_items_id_get>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiWizardResultItemsIdGet<TData = Awaited<ReturnType<typeof api_wizard_result_items_id_get>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_wizard_result_items_id_get>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof api_wizard_result_items_id_get>>,
          TError,
          Awaited<ReturnType<typeof api_wizard_result_items_id_get>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiWizardResultItemsIdGet<TData = Awaited<ReturnType<typeof api_wizard_result_items_id_get>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_wizard_result_items_id_get>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a WizardResultItem resource.
 */

export function useApiWizardResultItemsIdGet<TData = Awaited<ReturnType<typeof api_wizard_result_items_id_get>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_wizard_result_items_id_get>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiWizardResultItemsIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type api_wizard_result_items_id_putResponse200 = {
  data: WizardResultItemJsonld
  status: 200
}

export type api_wizard_result_items_id_putResponse400 = {
  data: void
  status: 400
}

export type api_wizard_result_items_id_putResponse404 = {
  data: void
  status: 404
}

export type api_wizard_result_items_id_putResponse422 = {
  data: void
  status: 422
}

export type api_wizard_result_items_id_putResponseSuccess = (api_wizard_result_items_id_putResponse200) & {
  headers: Headers;
};
export type api_wizard_result_items_id_putResponseError = (api_wizard_result_items_id_putResponse400 | api_wizard_result_items_id_putResponse404 | api_wizard_result_items_id_putResponse422) & {
  headers: Headers;
};

export type api_wizard_result_items_id_putResponse = (api_wizard_result_items_id_putResponseSuccess | api_wizard_result_items_id_putResponseError)

export const getApiWizardResultItemsIdPutUrl = (id: string,) => {




  return `/api/wizard_result_items/${id}`
}

/**
 * Replaces the WizardResultItem resource.
 * @summary Replaces the WizardResultItem resource.
 */
export const api_wizard_result_items_id_put = async (id: string,
    apiWizardResultItemsIdPutBody: NonReadonly<WizardResultItemJsonld | WizardResultItem>, options?: RequestInit): Promise<api_wizard_result_items_id_putResponse> => {

  return apiCatalog<api_wizard_result_items_id_putResponse>(getApiWizardResultItemsIdPutUrl(id),
  {
    ...options,
    method: 'PUT'
    ,
    body: JSON.stringify(apiWizardResultItemsIdPutBody)
  }
);}





export const getApiWizardResultItemsIdPutMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof api_wizard_result_items_id_put>>, TError,{id: string;data: NonReadonly<WizardResultItemJsonld | WizardResultItem>}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof api_wizard_result_items_id_put>>, TError,{id: string;data: NonReadonly<WizardResultItemJsonld | WizardResultItem>}, TContext> => {

const mutationKey = ['apiWizardResultItemsIdPut'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof api_wizard_result_items_id_put>>, {id: string;data: NonReadonly<WizardResultItemJsonld | WizardResultItem>}> = (props) => {
          const {id,data} = props ?? {};

          return  api_wizard_result_items_id_put(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiWizardResultItemsIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof api_wizard_result_items_id_put>>>
    export type ApiWizardResultItemsIdPutMutationBody = NonReadonly<WizardResultItemJsonld | WizardResultItem>
    export type ApiWizardResultItemsIdPutMutationError = void

    /**
 * @summary Replaces the WizardResultItem resource.
 */
export const useApiWizardResultItemsIdPut = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof api_wizard_result_items_id_put>>, TError,{id: string;data: NonReadonly<WizardResultItemJsonld | WizardResultItem>}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof api_wizard_result_items_id_put>>,
        TError,
        {id: string;data: NonReadonly<WizardResultItemJsonld | WizardResultItem>},
        TContext
      > => {
      return useMutation(getApiWizardResultItemsIdPutMutationOptions(options), queryClient);
    }
    export type api_wizard_result_items_id_deleteResponse204 = {
  data: void
  status: 204
}

export type api_wizard_result_items_id_deleteResponse404 = {
  data: void
  status: 404
}

export type api_wizard_result_items_id_deleteResponseSuccess = (api_wizard_result_items_id_deleteResponse204) & {
  headers: Headers;
};
export type api_wizard_result_items_id_deleteResponseError = (api_wizard_result_items_id_deleteResponse404) & {
  headers: Headers;
};

export type api_wizard_result_items_id_deleteResponse = (api_wizard_result_items_id_deleteResponseSuccess | api_wizard_result_items_id_deleteResponseError)

export const getApiWizardResultItemsIdDeleteUrl = (id: string,) => {




  return `/api/wizard_result_items/${id}`
}

/**
 * Removes the WizardResultItem resource.
 * @summary Removes the WizardResultItem resource.
 */
export const api_wizard_result_items_id_delete = async (id: string, options?: RequestInit): Promise<api_wizard_result_items_id_deleteResponse> => {

  return apiCatalog<api_wizard_result_items_id_deleteResponse>(getApiWizardResultItemsIdDeleteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getApiWizardResultItemsIdDeleteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof api_wizard_result_items_id_delete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof api_wizard_result_items_id_delete>>, TError,{id: string}, TContext> => {

const mutationKey = ['apiWizardResultItemsIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof api_wizard_result_items_id_delete>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  api_wizard_result_items_id_delete(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiWizardResultItemsIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof api_wizard_result_items_id_delete>>>

    export type ApiWizardResultItemsIdDeleteMutationError = void

    /**
 * @summary Removes the WizardResultItem resource.
 */
export const useApiWizardResultItemsIdDelete = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof api_wizard_result_items_id_delete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof api_wizard_result_items_id_delete>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getApiWizardResultItemsIdDeleteMutationOptions(options), queryClient);
    }
    export type api_wizard_result_items_id_patchResponse200 = {
  data: WizardResultItemJsonld
  status: 200
}

export type api_wizard_result_items_id_patchResponse400 = {
  data: void
  status: 400
}

export type api_wizard_result_items_id_patchResponse404 = {
  data: void
  status: 404
}

export type api_wizard_result_items_id_patchResponse422 = {
  data: void
  status: 422
}

export type api_wizard_result_items_id_patchResponseSuccess = (api_wizard_result_items_id_patchResponse200) & {
  headers: Headers;
};
export type api_wizard_result_items_id_patchResponseError = (api_wizard_result_items_id_patchResponse400 | api_wizard_result_items_id_patchResponse404 | api_wizard_result_items_id_patchResponse422) & {
  headers: Headers;
};

export type api_wizard_result_items_id_patchResponse = (api_wizard_result_items_id_patchResponseSuccess | api_wizard_result_items_id_patchResponseError)

export const getApiWizardResultItemsIdPatchUrl = (id: string,) => {




  return `/api/wizard_result_items/${id}`
}

/**
 * Updates the WizardResultItem resource.
 * @summary Updates the WizardResultItem resource.
 */
export const api_wizard_result_items_id_patch = async (id: string,
    wizardResultItem: WizardResultItem, options?: RequestInit): Promise<api_wizard_result_items_id_patchResponse> => {

  return apiCatalog<api_wizard_result_items_id_patchResponse>(getApiWizardResultItemsIdPatchUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/merge-patch+json', ...options?.headers },
    body: JSON.stringify(wizardResultItem)
  }
);}





export const getApiWizardResultItemsIdPatchMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof api_wizard_result_items_id_patch>>, TError,{id: string;data: WizardResultItem}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof api_wizard_result_items_id_patch>>, TError,{id: string;data: WizardResultItem}, TContext> => {

const mutationKey = ['apiWizardResultItemsIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof api_wizard_result_items_id_patch>>, {id: string;data: WizardResultItem}> = (props) => {
          const {id,data} = props ?? {};

          return  api_wizard_result_items_id_patch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiWizardResultItemsIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof api_wizard_result_items_id_patch>>>
    export type ApiWizardResultItemsIdPatchMutationBody = WizardResultItem
    export type ApiWizardResultItemsIdPatchMutationError = void

    /**
 * @summary Updates the WizardResultItem resource.
 */
export const useApiWizardResultItemsIdPatch = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof api_wizard_result_items_id_patch>>, TError,{id: string;data: WizardResultItem}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof api_wizard_result_items_id_patch>>,
        TError,
        {id: string;data: WizardResultItem},
        TContext
      > => {
      return useMutation(getApiWizardResultItemsIdPatchMutationOptions(options), queryClient);
    }
